const pains = [
  { emoji: '😤', text: 'Tu perds de l\'argent sur tes investissements sans comprendre pourquoi' },
  { emoji: '😕', text: 'Tu ne sais pas par où commencer, les marchés te semblent inaccessibles' },
  { emoji: '😰', text: 'Tu as peur de perdre ton capital et tu hésites à passer à l\'action' },
  { emoji: '😩', text: 'Les "experts" te donnent des conseils contradictoires et tu ne sais plus qui croire' },
];

const PainPointsSection = () => (
  <section className="bg-white py-16 px-8 lg:px-16">
    <div className="max-w-[1272px] mx-auto">
      <h2 className="text-[#1E0750] font-black text-3xl lg:text-4xl text-center mb-10">
        Comment tu te sens quand...
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {pains.map((p, i) => (
          <div key={i} className="bg-[#F5F0FF] border border-[#E2D9F3] rounded-2xl p-6 flex flex-col items-center text-center gap-4">
            <span className="text-5xl">{p.emoji}</span>
            <p className="text-[#1E0750] text-sm font-medium leading-relaxed">{p.text}</p>
          </div>
        ))}
      </div>
      {/* Arrow down */}
      <div className="flex justify-center mt-10">
        <div className="flex flex-col items-center gap-1">
          <div className="text-[#F0C932] text-3xl font-black">↓</div>
          <div className="text-[#F0C932] text-3xl font-black">↓</div>
        </div>
      </div>
    </div>
  </section>
);

export default PainPointsSection;
